<div>
  <h6 class="u-h6 u-dark-grey">{{ certificate.description }}</h6>
</div>
<img class="pdf-image" src="assets/imgs/ptrab/download-certificate.svg" alt="Cerfificate" item-end />
